import { Account } from '../types';
import api from '../API';

export default {
  find(id: number): Promise<Account> {
    return api
      .get(`accounts/${id}`)
      .then(response => response.data);
  },
  findAll(clientId: number): Promise<Account[]> {
    return api
      .get(`clients/${clientId}/accounts`)
      .then(response => response.data);
  },
};
